import { Component, inject, signal } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'qwiko-onboarding-nav',
  imports: [TranslocoModule],
  templateUrl: './onboarding-nav.component.html',
  styleUrl: './onboarding-nav.component.scss',
})
export class OnboardingNavComponent {
  private authService = inject(AuthService);
  loading = signal<boolean>(false);

  async signOut() {
    this.loading.set(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    await this.authService.signOut();
  }
}
